<template>
  <content-container :overlay="loading" :container="true">
    <h1>пока ничего нет</h1>
  </content-container>
</template>

<script>
import ContentContainer from "@/components/ContentContainer";

export default {
  name: "UserBillingSummary",
  components: {
    ContentContainer,
  },
  data() {
    return {
      loading: false,
    };
  },
};
</script>

<style>

</style>